import styled from 'styled-components'

const RadioInputUi = styled.input`
  margin-right: 5px;
`

export default RadioInputUi
